import { apiConstants } from '../../apiConstant'
import { serviceCallAuth } from '../../serviceCall'

export const forgotPassword = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCallAuth({
      url: apiConstants.AUTH.FORGOT_PASSWORD,
      method: 'post',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
